import { render, staticRenderFns } from "./realTimeMonitoringtwo.vue?vue&type=template&id=c38fff36&scoped=true"
import script from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
export * from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
import style0 from "./realTimeMonitoringtwo.vue?vue&type=style&index=0&id=c38fff36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38fff36",
  null
  
)

export default component.exports